<!-- Linha 1: número, badge de vencido, avatar do responsável e ações.
     O avatar e o ⋮ ficam no topo, como no protótipo — a story os descrevia no rodapé. -->
<div class="pv-card-top">
    <span class="pv-card-numero">#{{ numeroExibido }}</span>

    @if (card.isVencido) {
        <span
            class="pv-card-vencido"
            matTooltip="Este orçamento venceu o prazo de validade. Qualquer movimentação exigirá liberação de gerente.">
            <mat-icon class="material-symbols-outlined">lock_clock</mat-icon>
            Vencido
        </span>
    }

    <span class="pv-card-spacer"></span>

    <span class="pv-avatar" [style.background]="corAvatar" [matTooltip]="card.nomeVendedor ?? 'Sem responsável'">
        {{ iniciaisVendedor }}
    </span>

    <!-- stopPropagation em duas frentes: o clique abriria o documento (o card inteiro é
         clicável) e o pointerdown iniciaria o arraste com o menu na mão. -->
    <button
        type="button"
        class="pv-icon-btn"
        matTooltip="Ações do card"
        [matMenuTriggerFor]="menuAcoes"
        (click)="$event.stopPropagation()"
        (pointerdown)="$event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
    </button>

    <!-- Os itens do protótipo, na ordem dele. "Editar registro" abre o documento como o clique no
         card (em leitura quando a etapa ou o lançamento bloqueiam a edição). -->
    <mat-menu #menuAcoes="matMenu">
        <button type="button" mat-menu-item (click)="editar.emit(card)">
            <mat-icon class="material-symbols-outlined">edit</mat-icon>
            <span>Editar registro</span>
        </button>

        <button type="button" mat-menu-item [disabled]="!podeClonar" (click)="clonar.emit(card)">
            <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
            <span>{{ card.idVendaTipoDocumento === vendaTipoDocumentoEnum.PedidoDeVenda ? 'Clonar venda' : 'Clonar orçamento' }}</span>
        </button>

        @if (!ehPedido) {
            <button type="button" mat-menu-item [disabled]="!podeCriarModelo" (click)="criarModelo.emit(card)">
                <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
                <span>Criar modelo</span>
            </button>
        }

        <button type="button" mat-menu-item (click)="verHistorico.emit(card)">
            <mat-icon class="material-symbols-outlined">history</mat-icon>
            <span>Ver histórico</span>
        </button>

        <!-- Financeiro (T05/T08): só no pedido. Lançar some quando já lançado ou com o pedido finalizado; Excluir, quando não há. -->
        @if (ehPedido && !card.isFinanceiroLancado && !card.isEtapaFinalizada) {
            <span [matTooltip]="'Você não tem permissão para lançar o financeiro.'" [matTooltipDisabled]="podeLancarFinanceiro" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeLancarFinanceiro" (click)="lancarFinanceiro.emit(card)">
                    <mat-icon class="material-symbols-outlined">payments</mat-icon>
                    <span>Lançar financeiro</span>
                </button>
            </span>
        }
        @if (ehPedido && card.isFinanceiroLancado) {
            <span [matTooltip]="'Você não tem permissão para excluir o financeiro.'" [matTooltipDisabled]="podeExcluirFinanceiro" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeExcluirFinanceiro" (click)="excluirFinanceiro.emit(card)">
                    <mat-icon class="material-symbols-outlined">money_off</mat-icon>
                    <span>Excluir financeiro</span>
                </button>
            </span>
        }
        <!-- Estoque (T10/T11): só no pedido. Lançar some quando já lançado ou com o pedido finalizado; Excluir, quando não há. -->
        @if (ehPedido && !card.isEstoqueLancado && !card.isEtapaFinalizada) {
            <span [matTooltip]="'Você não tem permissão para lançar o estoque.'" [matTooltipDisabled]="podeLancarEstoque"
                matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeLancarEstoque" (click)="lancarEstoque.emit(card)">
                    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                    <span>Lançar estoque</span>
                </button>
            </span>
        }
        @if (ehPedido && card.isEstoqueLancado) {
            <span [matTooltip]="'Você não tem permissão para excluir o estoque.'" [matTooltipDisabled]="podeExcluirEstoque"
                matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeExcluirEstoque" (click)="excluirEstoque.emit(card)">
                    <mat-icon class="material-symbols-outlined">undo</mat-icon>
                    <span>Excluir estoque</span>
                </button>
            </span>
        }

        <button type="button" mat-menu-item [disabled]="!podeExcluir" (click)="excluir.emit(card)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir</span>
        </button>

        <!-- Grupo da oportunidade (D3, RX-01 a RX-06), depois da régua como no protótipo. Os itens sempre
             aparecem; sem Visualizar do CRM ficam desativados com o tooltip da RX-05. Modelo não tem
             oportunidade: só "Ver oportunidades do cliente", que já existia. -->
        @let acoes = acoesOportunidade;
        <mat-divider></mat-divider>
        @if (!ehModelo) {
            @if (card.idOportunidade != null) {
                @if (card.isOportunidadeForaDoEscopo) {
                    <span [matTooltip]="tooltipOportunidadeOutroVendedor" matTooltipPosition="left">
                        <button type="button" mat-menu-item disabled [attr.aria-label]="tooltipOportunidadeOutroVendedor">
                            <mat-icon class="material-symbols-outlined">lock</mat-icon>
                            <span>Oportunidade de outro vendedor</span>
                        </button>
                    </span>
                } @else {
                    <span [matTooltip]="acoes.motivoVer" matTooltipPosition="left">
                        <button type="button" mat-menu-item [disabled]="!!acoes.motivoVer"
                            [attr.aria-label]="acoes.motivoVer || null" (click)="verOportunidade.emit(card)">
                            <mat-icon class="material-symbols-outlined">handshake</mat-icon>
                            <span>{{ acoes.rotuloVer }}</span>
                        </button>
                    </span>
                    <span [matTooltip]="acoes.motivoDesvincular" matTooltipPosition="left">
                        <button type="button" mat-menu-item [disabled]="!!acoes.motivoDesvincular"
                            [attr.aria-label]="acoes.motivoDesvincular || null" (click)="desvincularOportunidade.emit(card)">
                            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                            <span>Desvincular da oportunidade</span>
                        </button>
                    </span>
                }
            } @else {
                <span [matTooltip]="acoes.motivoCriar" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoCriar"
                        [attr.aria-label]="acoes.motivoCriar || null" (click)="criarOportunidade.emit(card)">
                        <mat-icon class="material-symbols-outlined">add_comment</mat-icon>
                        <span>Criar oportunidade</span>
                    </button>
                </span>
                <span [matTooltip]="acoes.motivoVincular" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoVincular"
                        [attr.aria-label]="acoes.motivoVincular || null" (click)="vincularOportunidade.emit(card)">
                        <mat-icon class="material-symbols-outlined">add_link</mat-icon>
                        <span>Vincular a oportunidade</span>
                    </button>
                </span>
            }
        }

        <span [matTooltip]="acoes.motivoVerDoCliente" matTooltipPosition="left">
            <button type="button" mat-menu-item [disabled]="!!acoes.motivoVerDoCliente"
                [attr.aria-label]="acoes.motivoVerDoCliente || null" (click)="verOportunidadesCliente.emit(card)">
                <mat-icon class="material-symbols-outlined">forum</mat-icon>
                <span>Ver oportunidades do cliente</span>
            </button>
        </span>
    </mat-menu>
</div>

<div class="pv-card-cliente">{{ card.nomePessoaCliente ?? 'Cliente não informado' }}</div>
<div class="pv-card-itens">{{ resumoItens }}</div>

<!-- RX-07: marca discreta do documento vinculado. O clique abre a ficha no CRM; stopPropagation em duas
     frentes, como no botão de ações: o clique abriria o documento e o pointerdown iniciaria o arraste. -->
@if (temMarcaOportunidade) {
    <button
        type="button"
        class="pv-chip-oportunidade"
        [matTooltip]="tooltipMarcaOportunidade"
        [attr.aria-label]="tooltipMarcaOportunidade"
        (click)="$event.stopPropagation(); verOportunidade.emit(card)"
        (pointerdown)="$event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">handshake</mat-icon>
        @if (!card.isOportunidadeForaDoEscopo) {
            <span>#{{ card.codigoOportunidade }}</span>
        }
    </button>
}

<!-- Integrações lançadas (E, F): as mesmas siglas e cores da coluna da lista. -->
@if (integracoes.length) {
    <div class="pv-card-integracoes indicador-grid">
        @for (integracao of integracoes; track integracao.sigla) {
            @if (integracao.isFinanceiro) {
                <!-- O clique não abre o card: o indicador F mostra os lançamentos do financeiro. -->
                <button type="button" class="indicador indicador-sm indicador-clicavel" [style.--indicador-cor]="integracao.cor"
                    [matTooltip]="integracao.rotulo" [attr.aria-label]="integracao.rotulo"
                    (click)="$event.stopPropagation(); verFinanceiro.emit(card)">{{ integracao.sigla }}</button>
            } @else {
                <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor"
                    [matTooltip]="integracao.rotulo" [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
            }
        }
    </div>
}

<!-- Rastro da conversão: o registro é o mesmo, então não há link para um documento separado. -->
@if (card.isOrigemOrcamento) {
    <span class="pv-chip-origem" matTooltip="Este pedido nasceu como orçamento — é o mesmo documento, com o mesmo número">
        <mat-icon class="material-symbols-outlined">call_merge</mat-icon>
        Convertido de orçamento
    </span>
}

@if (isFaixaExterna && card.numeroExpedicao != null) {
    <div class="pv-chip-transito" matTooltip="Expedição associada a este pedido">
        <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
        Expedição nº {{ card.numeroExpedicao }}
    </div>
}

<!-- Progresso reportado pela rotina externa. Somente leitura no Kanban. -->
@if (card.percentualProgresso != null) {
    <div class="pv-progresso">
        <div class="pv-progresso-topo">
            <span>{{ rotuloProgresso }}</span>
            <span class="pv-progresso-pct">{{ card.percentualProgresso }}%</span>
        </div>
        <div class="pv-progresso-trilho">
            <div class="pv-progresso-barra" [style.width.%]="card.percentualProgresso"></div>
        </div>
    </div>
}

@if (card.tags.length > 0) {
    <div class="pv-card-tags">
        @for (tag of card.tags; track tag.idTagVenda) {
            <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
        }
    </div>
}

<div class="pv-card-footer">
    <span class="pv-card-valor">{{ card.valorTotal | abnt: 'preco' : 2 }}</span>
    <span class="pv-card-data" [matTooltip]="tituloDataRodape">
        <mat-icon class="material-symbols-outlined">event</mat-icon>
        @if (ehModelo || !dataRodape) {
        <!-- Modelo é molde, não documento com data: exibir a data de criação dele sugeriria
             uma validade que ele não tem. Orçamento sem próximo contato também fica em branco:
             a data do orçamento no lugar passaria por contato marcado. -->
        —
        } @else {
        {{ dataRodape | date: 'dd/MM/yyyy' }}
        }
    </span>
</div>
